import Vue from 'vue'
import axios from 'axios'
import VueGtm from 'vue-gtm'
import Router from 'vue-router'
import { loadLanguageAsync } from '../lang/lang'
import Login from '@/components/views/login/index'
import SignUp from '@/components/views/signUp/index'
import AccountCreated from '@/components/views/accountCreated/index'
import AccountRecovery from '@/components/views/AccountRecovery/index'
import EmailConfirmation from '@/components/views/EmailConfirmation/index'
import ResetPassword from '@/components/views/ResetPassword/index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/:lang/entrar/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/:lang/entrar/recuperar-conta',
      name: 'AccountRecovery',
      component: AccountRecovery
    },
    {
      path: '/:lang/entrar/registar',
      name: 'SignUp',
      component: SignUp,
      beforeEnter: (to, from, next) => {
        if (Object.keys(to.query).length === 0) {
          next()
        }

        axios.get(`${process.env.API_URL}/customer/info/${to.query.customer}`)
          .then(({data}) => {
            if (!data.valid) {
              next(to.meta.customer = {
                data
              })
            }

            next(to.meta.customer = {
              data
            })
          }).catch((error) => {
            const statusCode = error.response.status

            next(to.meta.errorCode = statusCode)
          })
      }
    },
    {
      path: '/:lang/entrar/conta-criada',
      name: 'AccountCreated',
      component: AccountCreated
    },
    {
      path: '/:lang/entrar/confirmar-email/',
      name: 'EmailConfirmation',
      component: EmailConfirmation,
      beforeEnter: (to, from, next) => {
        axios.get(`${process.env.API_URL}/user/email-confirmation/${to.query.user}/${to.query.token}`)
        .then((response) => {
          if (response.data.valid) {
            to.params.isValid = true
            to.params.isPhoneVerified = response.data.status.is_phone_confirmed
            to.params.isActive = response.data.status.is_active

            next()
          } else {
            to.params.isValid = false
            next()
          }
        })
      }
    },
    {
      path: '/:lang/entrar/nova-password',
      name: 'ResetPassword',
      component: ResetPassword,
      beforeEnter: (to, from, next) => {
        axios.get(`${process.env.API_URL}/user/reset-password/check/?token=${to.query.token}`)
        .then(({data}) => {
          if (data.valid) {
            to.params.isValid = true
            next()
          } else {
            to.params.isValid = false
            next()
          }
        })
      }
    }
  ]
})

const handleCSRF = (to, from, next) => {
  if (axios.defaults.headers.common['X-CSRF-TOKEN'] !== undefined) {
    return next()
  };

  axios.get(`${process.env.API_URL}/getcsrftoken`, {
    credentials: 'same-origin',
    withCredentials: 'true'
  })
  .then((response) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken
    return next()
  })
}

router.beforeEach(async(to, from, next) => {
  const languange = to.params.lang
  const { data } = await axios.get(`${process.env.API_URL}/locale`)
  const activeLanguages = data.activeLanguages.map((language) => language.iso2)

  if (activeLanguages.includes(languange)) {
    await loadLanguageAsync(languange)
    return handleCSRF(to, from, next)
  }

  await loadLanguageAsync(data.bestMatch)
  return handleCSRF(to, from, next)
})

Vue.use(VueGtm, {
  id: 'GTM-W87575M',
  enabled: process.env.NODE_ENV === 'production',
  vueRouter: router
})

export default {
  router
}



// WEBPACK FOOTER //
// ./src/router/index.js